import {Modal} from "antd";

export const AntdModal = ({
	title,
	isModalVisible,
	onCancel,
	onOk,
	children,
	headStyle = {},
	destroyOnClose = false,
}) => (
	<Modal
		width={"65vw"}
		destroyOnClose={destroyOnClose}
		title={
			<div style={headStyle} data-testid="antd-modal-title">
				{title}
			</div>
		}
		styles={{body: {padding: "10px 20px"}}}
		open={isModalVisible}
		onCancel={onCancel}
		onOk={onOk}
		data-testid="antd-modal-container">
		{children}
	</Modal>
);
